import React, { Suspense } from "react";
import { useParams } from "react-router";

import UnitMain from "./UnitMain";
import LoadingScreen from "../../components/LoadingScreen";
import { useQuery } from "@tanstack/react-query";
import { qoGetMccUnitDetails, qoTodaysUnit } from "../../utils/queryOptions";
import { useAuth } from "../../hooks/useAuth";
import { useSqids } from "../../hooks/useSqids";
import { UnitContextProvider } from "../../contexts/UnitContextProvider";
import { useEffect } from "react";

// ZOOM DEVRE DIŞI — dummy component
// const ZoomMain = React.lazy(() => import("../zoom/ZoomMain"));
const ZoomMain = (_props: Record<string, unknown>) => <div />;

export default function UnitLoader() {
  const { unitSlugWithId } = useParams();
  const sqids = useSqids();

  const encodedId = unitSlugWithId!.split("-").pop(); // "UkLWZg"
  // ders idsini bul
  const unitId = sqids.decode(encodedId!);

  const { user, isFulltimeSelfUser } = useAuth();

  // bugünün dersi mi söz konusu olan? eğer öyleyse zoom bilgilerini al
  const { data: liveUnitDetails, isSuccess: liveUnitDetailsSuccess } = useQuery(
    qoTodaysUnit({
      cohort_id: user?.cohort_id,
    })
  );

  // ders detaylarını çek
  // isFetchedAfterMount: kaldığı yer (offline_logs) UnitContextProvider'da sadece
  // mount'ta okunuyor. Cache'teki eski veriyle render edersek öğrenci derse geri
  // döndüğünde eski konumdan başlıyor ve ilk tıklamasında doğru kaydı eziyordu.
  // O yüzden her açılışta sunucudan taze veri gelene kadar bekliyoruz.
  const {
    data: unitDetails,
    isSuccess: unitDetailsSuccess,
    isFetchedAfterMount: unitDetailsFresh,
  } = useQuery(
    qoGetMccUnitDetails({
      cohort_id: user?.cohort_id || 1,
      unit_id: unitId!,
      user_id: user?.id || 1,
      add_intro: !isFulltimeSelfUser
    })
  );

  const isLive =
    liveUnitDetailsSuccess && liveUnitDetails?.unit_live_status === "ONGOING";

  // canlı derste sayfayı yenilemeyi ya da kapatmayı denerse
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    if (isLive) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      if (isLive) {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
  }, [isLive]);

  return unitDetailsSuccess && unitDetailsFresh ? (
    <UnitContextProvider
      key={unitDetails[0].module_cohort_content_id}
      unit={unitDetails[0]}
      liveDetails={liveUnitDetails}
      isLive={isLive}
    >
      <UnitMain>
        {/* canlı ders detayları geldiyse ve ders canlıysa */}
        {isLive && (
          <Suspense fallback={<LoadingScreen text="Canlı ders yükleniyor..." />}>
            <ZoomMain
              meetingDbRecord={liveUnitDetails.zoom_info!}
              cohorts={liveUnitDetails.cohorts}
              mccId={liveUnitDetails.module_cohort_content_id}
            />
          </Suspense>
        )}
      </UnitMain>
    </UnitContextProvider>
  ) : (
    <LoadingScreen text="Ders yükleniyor..." fullScreen />
  );
}
